<template>
  <div
    class="
      tw-z-20
      tw-absolute
      tw-left-0
      tw-top-0
      tw-h-full
      tw-w-full
      tw-text-center
      tw-pt-3
    "
  >
    <div
      class="
        tw-bg-white
        tw-p3
        tw-opacity-80
        tw-absolute
        tw-left-0
        tw-top-0
        tw-h-full
        tw-w-full
      "
    >
      <svg
        class="
          tw-animate-spin
          tw-ml-2
          tw-mr-3
          tw-h-10
          tw-w-10
          tw-text-noraBlue-500
          tw-absolute
          tw-left-1/2
          tw--ml-10
          tw-top-1/4
        "
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="tw-opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="tw-opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: () => "white",
    },
  },
};
</script>

<style scoped>
.loader {
  width: 1em;
  height: 1em;
}
.loader .spinner {
  @apply tw-box-border tw-block tw-absolute tw-rounded-full tw-border-solid;
  width: 0.9em;
  height: 0.9em;
  margin: 0.1em;
  border-width: 0.1em;
  animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
.loader .spinner:nth-child(1) {
  animation-delay: -0.45s;
}
.loader .spinner:nth-child(2) {
  animation-delay: -0.3s;
}
.loader .spinner:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
